//import App from './App.svelte';
//import App from './App2.svelte';
import App from './AppMain.svelte';

var app = new App({
	target: document.body
});